module.exports = __webpack_public_path__ + "img/7.c5f725df.svg";